module.exports = __webpack_public_path__ + "img/greeksoft.dc8821c5.png";